
import React, { Fragment, useContext } from 'react';
import { appPath, APP_PATHS } from '../../../utils/appPaths.js';
import sad from '../../../assets/images/other-images/sad.png';
import { Link } from 'react-router-dom';
import { Container, Button, Media, Col } from "reactstrap"
import { BACK_TO_HOME_PAGE } from "../../../Constant";
import { H2, P } from '../../../AbstractElements';
import CustomizerContext from '../../../_helper/Customizer';

const Error403 = () => {
    const { layoutURL } = useContext(CustomizerContext);
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="error-wrapper">
                    <Container>
                        <Media body className="img-100" src={sad} alt="" />
                        <div className="error-heading">
                            <H2 attrH2={{ className: "headline font-success" }} >{"403"}</H2>
                        </div>
                        <Col md="8 offset-md-2">
                            <P attrPara={{ className: "sub-content mb-2" }} >{"The page you are attempting to reach is currently restricted based on your role."}</P>
                            <P attrPara={{ className: "sub-content text-danger mb-4" }}>{`Your recorded Role is: ${localStorage.getItem("userDataRole") || 'Not Detected in State'}`}</P>
                        </Col>
                        <Link to={appPath('/login')}><Button color="success-gradien" size='lg'>{"GO TO LOGIN"}</Button></Link>
                    </Container>
                </div>
            </div>
        </Fragment>
    );
};

export default Error403;